export const DRAWER_LABELLED_BY = 'drawer-title';
